import TAB from 'constants/tab';

const {
  ADD_LOCATION_BY_STEP,

  CHANGE_TAB,
  SUBMIT_ADD_LOCATION_SUCCESS,
} = require('./actionTypes');

const initialState = {
  step: TAB.BASIC,
  location: {},
  stepAvailable: [TAB.BASIC],
};

const editLocation = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LOCATION_BY_STEP:
      return {
        ...state,
        step: action.payload.step,
        stepAvailable: state.stepAvailable.includes(action.payload.step)
          ? state.stepAvailable
          : state.stepAvailable.concat(action.payload.step),
        location: { ...state.location, ...action.payload.location },
      };

    case CHANGE_TAB:
      return {
        ...state,
        step: state.stepAvailable.includes(action.payload.step) ? action.payload.step : state.step,
      };

    case SUBMIT_ADD_LOCATION_SUCCESS: {
      return initialState;
    }

    default:
      return state;
  }
};

export default editLocation;
